var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefreshCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.linesandangles_een{fill:#111918;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "linesandangles_een",
    d: "M20.95,20.949l1.414,1.414C20.665,24.063,18.404,25,16,25c-4.962,0-9-4.037-9-9v-0.586 l-2.293,2.293l-1.414-1.414L8,11.586l4.707,4.707l-1.414,1.414L9,15.414V16c0,3.859,3.14,7,7,7C17.87,23,19.628,22.271,20.95,20.949 z M27.293,14.293L25,16.586V16c0-4.963-4.038-9-9-9c-2.404,0-4.665,0.937-6.364,2.637l1.414,1.414C12.372,9.729,14.13,9,16,9 c3.86,0,7,3.141,7,7v0.586l-2.293-2.293l-1.414,1.414L24,20.414l4.707-4.707L27.293,14.293z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCircle);
export default __webpack_public_path__ + "static/media/RefreshCircle.dfe44c7a6cbbd717a61c7c381f4c5ff0.svg";
export { ForwardRef as ReactComponent };